import axios, { AxiosRequestConfig } from "axios";
// @ts-ignore
import Constant from "../utils/constant";
// @ts-ignore
import { goToPage, isNotNull } from "../utils/index";

const baseURL = (import.meta as any).env.VITE_API_BASE_URL;

const instance = axios.create({
  baseURL: baseURL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
  },
});

instance.interceptors.request.use(
  (config) => {
    // 直接从localStorage获取token，避免循环依赖
    const token = localStorage.getItem("token");
    if (isNotNull(token)) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => {
    const rt = response.config.responseType;
    if (rt === "blob" || rt === "arraybuffer") {
      if (response.status === 200) {
        return {
          data: response.data,
          headers: response.headers,
          status: response.status,
        };
      }
      return Promise.reject(new Error(`请求失败 (${response.status})`));
    }
    const res = response.data;
    if (res.code === 0 || res.code === "success" || res.code === undefined) {
      return res.data;
    } else if (res.code === 401) {
      localStorage.removeItem("token");
      goToPage(Constant.PAGE.LOGIN, true);
      return Promise.reject(new Error(res.message || "未授权"));
    } else if (res.code === 46002) {
      if (window.location.pathname !== '/age-profile') window.location.assign('/age-profile');
      return Promise.reject(new Error(res.message || "请先完成年龄准入要求"));
    } else {
      return Promise.reject(new Error(res.message || "请求失败"));
    }
  },
  (error) => Promise.reject(error)
);

const httpRequest = {
  get<T = any>(url: string, config: AxiosRequestConfig = {}): Promise<T> {
    return instance.get(url, config);
  },
  post<T = any>(
    url: string,
    data: any = {},
    config: AxiosRequestConfig = {}
  ): Promise<T> {
    return instance.post(url, data, config);
  },
  put<T = any>(
    url: string,
    data: any = {},
    config: AxiosRequestConfig = {}
  ): Promise<T> {
    return instance.put(url, data, config);
  },
  delete<T = any>(url: string, config: AxiosRequestConfig = {}): Promise<T> {
    return instance.delete(url, config);
  },
};

export default httpRequest;
